import type { Identity } from '@clockworklabs/spacetimedb-sdk'
import type { ShallowRef } from 'vue'
import { DbConnection } from '~/assets/bindings'

// shallowRef only allows watching for root .value changes, and does not proxy the object
// proxying the database breaks it, as it is no longer an instance of the correct class
const connection: ShallowRef<DbConnection | null> = shallowRef(null)
let connecting = false
let handlerSet = false

const useDatabase = (): Ref<DbConnection | null> => {
  const connect = () => {
    console.log('[DB] Connecting...')
    DbConnection.builder()
      //.withUri('ws://localhost:8080')
      .withUri('wss://maincloud.spacetimedb.com/')
      .withModuleName('estia-server')
      .withToken(localStorage.getItem('authToken') || '')
      .onConnect((conn: DbConnection, identity: Identity, token: string) => {
        connection.value = conn
        console.log('[DB] Connected as ', identity.toHexString())
        localStorage.setItem('authToken', token)
      })
      .onConnectError((_ctx, error) => {
        console.log('[DB] Connection error:', error)
        connection.value = null
      })
      .onDisconnect(() => () => {
        console.log('[DB] Disconnected')
        connection.value = null
      })
      .build()
  }
  if (!import.meta.server && !connection.value && !connecting) {
    connecting = true
    connect()

    if (!handlerSet) {
      handlerSet = true
      document.body.addEventListener('focus', () => {
        if (!connection.value) connect()
      })
    }
  }

  return computed(() => {
    if (connection.value?.isActive) return connection.value
    return null
  })
}

export default useDatabase
